var lib_geometry = require("lib-geometry");
var colors = require("./../../colors/colors.js");

var SelectionView = function (model, editorView, cameraModel) {
    var self = this;

    this.cameraModel = cameraModel;

    this.selectionModel = model;
    this.editorView = editorView; // TODO: get rid of this dependency

    this.selectControl = this.editorView.svg.group(this.editorView.zoomGroup);

    self.selectionModel.selection_box_end.onChange('view', function(){
        if (self.selectionModel.selection_box_end() != null) {
            var direction = self.selectionModel.selection_box_start().getX() <
                self.selectionModel.selection_box_end().getX();
            var bb = new lib_geometry.PointSet([self.selectionModel.selection_box_start(), self.selectionModel.selection_box_end()]).getBB();
            self.drawSelectBox(bb, direction);
        } else {
            self.removeSelectBox();
        }
    },10);
};

module.exports = SelectionView;

SelectionView.prototype.drawSelectBox = function(bb, direction) {
    this.removeSelectBox();

    var dash = colors.selectionLR.strokeDashArray / this.cameraModel.viewS();

    // colors change based on direction of selection box
    if(direction) {
        this.selectBox = this.editorView.svg.rect(this.selectControl, bb['x'], bb['y'], bb['width'], bb['height'], {
            'fill': colors.selectionRL.fill,
            'fillOpacity': colors.selectionRL.fillOpacity,
            'stroke': colors.selectionRL.stroke,
            'strokeOpacity': colors.selectionRL.strokeOpacity,
            'strokeWidth': 1 / this.cameraModel.viewS()
        });
    } else {
        this.selectBox = this.editorView.svg.rect(this.selectControl, bb['x'], bb['y'], bb['width'], bb['height'], {
            'fill': colors.selectionLR.fill,
            'fillOpacity': colors.selectionLR.fillOpacity,
            'stroke': colors.selectionLR.stroke,
            'strokeOpacity': colors.selectionLR.strokeOpacity,
            'strokeWidth': 1 / this.cameraModel.viewS(),
            // documentation says use camelcase, but this must not be supported
            // this still works
            "stroke-dasharray": dash+","+dash
        });
    }
};

SelectionView.prototype.removeSelectBox = function() {
    $(this.selectBox).remove();
};

